module.exports = __webpack_public_path__ + "img/old-app.584917f8.png";